import { Platform } from 'react-native';
import { PERMISSIONS, RESULTS, check, request } from 'react-native-permissions';

const checkCameraPermission = async (onPermissionGranteed, onCameraBlocked) => {
  const isAndroid = Platform.OS === 'android';
  const permissionToCheck = isAndroid ? PERMISSIONS.ANDROID.CAMERA : PERMISSIONS.IOS.CAMERA;

  check(permissionToCheck).then(result => {
    if (result === RESULTS.GRANTED) {
      onPermissionGranteed();
    } else if (result === RESULTS.DENIED) {
      request(permissionToCheck).then(permissionRequestedResult => {
        if (permissionRequestedResult === RESULTS.GRANTED) {
          onPermissionGranteed();
        } else if (isAndroid && permissionRequestedResult === RESULTS.BLOCKED) {
          onCameraBlocked();
        }
      });
    } else if (result === RESULTS.BLOCKED) {
      onCameraBlocked();
    }
  });
};

export default checkCameraPermission;
